import { apiClient } from './apiClient';
export const searchPorts = async (query) => {
    const response = await apiClient.get('/api/v1/query/search/ports', { params: { query } });
    return response.data;
};
export const searchAirports = async (query) => {
    const response = await apiClient.get('/api/v1/query/search/airports', { params: { query } });
    return response.data;
};
export const searchHsCodes = async (query, limit = 50) => {
    const response = await apiClient.get('/api/v1/query/search/hs-codes', { params: { q: query, limit } });
    return response.data;
};
export const getHsCodeDetails = async (code) => {
    const response = await apiClient.get(`/api/v1/query/hs-code/${code}`);
    return response.data;
};
export const getUnitTypes = async () => {
    const response = await apiClient.get('/api/v1/query/unit-types');
    return response.data;
};
